/// <reference path='common.ts' />
/// <reference path='element_bind.ts' />

declare var Uppy: any;

/**
 * Uppyを使ったファイルアップロード処理を行います。
 *
 * 属性
 * data-upload-open: ファイルアップロードのダイアログを表示する
 * data-upload-url: ファイルのアップロード先URL
 * data-upload-inline: ファイルアップロードのエリアを表示する（idがない場合は"haori-file-area"が設定されます）
 * data-upload-audio: 録音に対応する
 * data-upload-camera: 録画に対応する
 * data-upload-screen: 画面録画に対応する
 * data-upload-max-count: 最大ファイル数
 * data-upload-bind-reload: アップロードに成功した際にリロードするdata-bind-fetch属性があるエレメントのセレクタ
 */
class HaoriFile {
  /** エレメントに対するUppyオブジェクトのマップ */
  private static uppys = new Map<Element, any>();

  /**
   * アトリビュートが変更された場合の処理を行います。
   *
   * @param mutations 変更情報のリスト
   */
  static attributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      let element = <HTMLElement>mutation.target;
      this.rebuild(element);
    });
  });

  /**
   * parentエレメント以下のテーブルエレメントにイベントを関連付け最初のフェッチを行います。
   */
  static bind(parent: HTMLElement) {
    parent.querySelectorAll('[data-upload-inline]').forEach((element) => {
      if (this.uppys.has(element)) {
        return;
      }
      if (element.getAttribute('id') == null) {
        element.setAttribute('id', 'haori-file-area-' + this.uppys.size);
      }
      this.build(element);
    });
  }

  /**
   * ファイルアップロードダイアログを表示します。
   *
   * @param element 対象エレメント
   */
  static open(element: Element) {
    let uppy = this.uppys.get(element);
    if (uppy == null) {
      if (element.getAttribute('id') == null) {
        element.setAttribute('id', 'haori-file-button-' + this.uppys.size);
      }
      uppy = this.build(element);
    }
    uppy.getPlugin('Dashboard').openModal();
  }

  /**
   * Uppyオブジェクトを作成します。
   *
   * @param element 対象エレメント
   * @return 作成したオブジェクト
   */
  private static build(element: Element): any {
    if (!element.hasAttribute('data-upload-url')) {
      return;
    }
    let uppy = new Uppy.Uppy({
      restrictions: {
        maxNumberOfFiles: element.getAttribute('data-upload-max-count'),
      },
    });
    uppy.use(Uppy.Dashboard, {
      target: '#' + element.id,
      proudlyDisplayPoweredByUppy: false,
      locale: Uppy.locales.ja_JP,
      inline: element.hasAttribute('data-upload-inline'),
      width: '100%',
      height: '500px',
      showProgressDetails: true,
    });
    if (element.hasAttribute('data-upload-audio')) {
      uppy.use(Uppy.Audio, { target: Uppy.Dashboard });
    }
    if (element.hasAttribute('data-upload-camera')) {
      uppy.use(Uppy.Webcam, { target: Uppy.Dashboard });
    }
    if (element.hasAttribute('data-upload-screen')) {
      uppy.use(Uppy.ScreenCapture, { target: Uppy.Dashboard });
    }
    uppy.use(Uppy.Tus, {
      endpoint: element.getAttribute('data-upload-url'),
      withCredentials: true,
    });
    uppy.on('complete', (result: any) => {
      if (result.successful.length == 0) {
        return;
      }
      if (element.hasAttribute('data-upload-bind-reload')) {
        document.querySelectorAll(element.getAttribute('data-upload-bind-reload')!).forEach((target) => {
          target.removeAttribute('data-bind-fetch-current');
          HaoriBind.doFetch(target);
        });
      }
    });
    this.uppys.set(element, uppy);
    return uppy;
  }

  /**
   * Uppyオブジェクトを再生成します。
   *
   * @param element 対象エレメント
   */
  static rebuild(element: Element) {
    let uppy = this.uppys.get(element);
    if (uppy != null) {
      uppy.close();
      this.uppys.delete(element);
    }
    this.build(element);
  }
}

window.addEventListener('load', (event) => {
  HaoriFile.bind(document.body);
});

document.body.addEventListener('load', (event) => {
  HaoriFile.bind(<HTMLElement>event.target);
});

document.body.addEventListener('click', (event) => {
  if ((<HTMLElement>event.target).closest('.uppy-Root') != null) {
    // Uppyのダイアログクリック
    return;
  }
  Haori.hasClosestAttribute(<HTMLElement>event.target, 'data-upload-open', (element) => {
    event.preventDefault();
    HaoriFile.open(element);
  });
});

HaoriFile.attributeObserver.observe(document.body, {
  attributes: true,
  subtree: true,
  attributeOldValue: true,
  attributeFilter: ['data-upload-url'],
});
